<template>
  <div class="mcontainer">
    <div class="breadcrumb-area py-0">
        <div class="breadcrumb">
            <ul class="m-0">
                <li>
                    <router-link to="/app/group">Groups</router-link>
                </li>
                <li class="active">
                    <a href="#">Create New Group </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="max-w-2xl m-auto shadow-md rounded-md bg-white mt-5">
        <form @submit.prevent="actionSubmit()">
            <div class="text-center border-b py-4">
                <h3 class="font-bold text-lg"> Create New Group </h3>
            </div>
            <div class="p-7 space-y-5">
                <div>
                    <label class="font-semibold">Group Name</label><br>
                    <input class="form-control" v-model="form.title" type="text" value="" autocomplete="off">
                </div>
                <div>
                    <label class="font-semibold text-base"> Group Category </label>
                    <select v-model="form.category_id" class="form-control">
                        <option value="">Select Group Category</option>
                        <option :value="category.id" v-for="category in categories" :key="category.id">{{ category.title }}</option>
                    </select>
                </div>
                <div>
                    <label class="font-semibold text-base">Group description</label>
                    <textarea class="form-control h-32"  v-model="form.description" type="text" value="" autocomplete="off"></textarea>
                </div>
                <div class="space-y-2">
                    <label class="font-semibold text-base">Group Privacy</label>
                    <div> Anyone can see who's in the group and what they post. </div>
                    <select v-model="form.privacy" class="form-control">
                        <option value="">Select Group Privacy</option>
                        <option value="private">Private</option>
                        <option value="unlisted">Unlisted</option>
                        <option value="public">Public</option>
                    </select>
                </div>
                <div>
                    <label class="font-semibold text-base">The reason for creating this group</label>
                    <textarea class="form-control h-32" value="" v-model="form.reason" type="text" autocomplete="off"></textarea>
                </div>
                <div>
                    <label class="font-semibold text-base">Examples of topics to be discussed</label>
                    <textarea class="form-control h-32" value="" v-model="form.topics" type="text" autocomplete="off"></textarea>
                </div>
                <div>
                    <label class="font-semibold">For MBKM ?</label>
                    <b-form-checkbox @change="forMbkm()" v-model="for_mbkm" name="check-button" switch>Check if group for MBKM program</b-form-checkbox>
                </div>
                <div v-if="for_mbkm">
                    <label class="font-semibold text-base">MBKM</label>
                    <multiselect v-model="form.mbkm_id" :options="mbkms" :multiple="true" :close-on-select="true" label="title" track-by="id"></multiselect>
                </div>
                <div>
                    <label class="font-semibold text-base">Preview</label><br>
                    <div class="image-uploader">
                        <input type="file" ref="preview" @change="onFileSelected($event, 'preview')">
                        <span @click="$refs.preview.click()"><Icon icon="bi:cloud-upload" /></span>
                        <img :src="preview ? preview : $placeholder2" alt="Preview" class="w-80">
                    </div>
                </div>
                <div>
                    <label class="font-semibold text-base">Logo</label><br>
                    <div class="image-uploader">
                        <input type="file" ref="logo" @change="onFileSelected($event, 'logo')">
                        <span @click="$refs.logo.click()"><Icon icon="bi:cloud-upload" /></span>
                        <img :src="logo ? logo : $placeholder2" alt="Logo" style="width: 150px;">
                    </div>
                </div>
            </div>
            <!-- form footer -->
            <div class="border-t flex justify-center border-gray-100 p-6">
                <button class="lg:w-1/3 h-9 lg:px-5 rounded-md bg-blue-600 text-white space-x-1.5 px-5" :class="disable_submit">
                    <span v-if="disable_submit == ''">Create Now</span>
                    <b-spinner v-if="disable_submit == 'disabled'" label="Loading..." small />
                </button>
            </div>
        </form>
    </div>
  </div>
</template>
<script>
    import axios from 'axios'
    import { Icon } from '@iconify/vue2'
    import Multiselect from 'vue-multiselect'
    import { toFormData } from '@/mixins'

    export default {
        name: 'CreateGroup',
        components: {
            Icon,
            Multiselect
        },
        data () {
            return {
                categories: [],
                mbkms: [],
                for_mbkm: 0,
                form: {
                    title: '',
                    category_id: '',
                    mbkm_id: '',
                    description: '',
                    privacy: '',
                    reason: '',
                    topics: '',
                    preview: '',
                    logo: ''
                },
                preview: '',
                logo: '',
                disable_submit: ''
            }
        },
        async created () {
            try {
                const res = await axios.get('category_group')
                const mbkms = await axios.get('mbkm')
                this.categories = res.data.result
                this.mbkms = mbkms.data.result
            } catch (e) {
                console.error(e)
            }
        },
        methods: {
            actionSubmit () {
                this.disable_submit = 'disabled'
                const $this = this
                axios.post('group/save', toFormData(this.form), {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(function (response) {
                    $this.disable_submit = ''
                    $this.$swal({
                        imageUrl: require('@/assets/images/vector-success.png'),
                        imageWidth: 400,
                        title: 'Berhasil Membuat Group',
                        text: response.data.message
                    }).then(function () {
                        $this.$router.push({ name: 'Group' })
                    })
                }).catch(function () {
                    $this.disable_submit = ''
                    $this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something Wrong'
                    })
                })
            },
            onFileSelected (e, target) {
                this.form[target] = e.target.files[0]
                this[target] = URL.createObjectURL(this.form[target])
            },
            forMbkm () {
                if (!this.for_mbkm) {
                    this.form.mbkm_id = 0
                }
            }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
